// Copyright (c) 2016 Deere & Company

import KeyValuePairCollection, {getDefaultState as getDefaultKeyValueCollectionState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../actions-list';

const updateClaimTypes = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.claimTypes
    });

export default (state = getDefaultKeyValueCollectionState(), action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_HISTORY_CLAIM_TYPES]: updateClaimTypes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/claim-history/reducers/claim-types.js